<template>
<div class="home page">
  <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

  <HomeHero @download="triggerDownload" />

  <div class="home-longform">
    <section class="section-content">
      <h1 class="home-longform__h1">
Why Choose GB WhatsApp?
</h1>
      <p><strong>More freedom, more customization, and more control.</strong></p>
      <p>
        <router-link to="/">
<strong>GB WhatsApp</strong>
</router-link> is designed for Android users who want features beyond the standard WhatsApp experience. It offers advanced privacy settings, customizable themes, larger media sharing, and productivity tools that help make everyday messaging more flexible.
      </p>
      <h3>🛡️ Better Privacy</h3>
      <p>Hide your online status, freeze last seen, hide blue ticks, and manage who can see your activity.</p>
      <h3>🎨 Full Customization</h3>
      <p>Personalize your chats with themes, fonts, wallpapers, icons, and color styles.</p>
      <h3>📁 Enhanced Media Sharing</h3>
      <p>Send larger videos, HD images, documents, and more files with fewer limitations.</p>
      <h3>⚡ Smart Messaging</h3>
      <p>Use Auto Reply, Message Scheduler, DND Mode, and other tools to simplify daily conversations.</p>
      <h3>📱 Easy to Use</h3>
      <p>Install on most Android devices and enjoy a familiar interface with extra features.</p>
      <h3>🔄 Regular Updates</h3>
      <p>
GB WhatsApp keeps you informed with the latest <router-link to="/">
<strong>GBWhatsApp APK</strong>
</router-link> releases, update guides, and version changes.
</p>
    </section>

    <section class="section-content">
      <h2>What's New in the Latest V18.80 Update?</h2>
      <p>The latest GB WhatsApp update focuses on <strong>better stability, improved compatibility, and a smoother messaging experience</strong>. Whether you're upgrading from an older version or installing for the first time, this release brings several noticeable improvements.</p>
      <h3>✓ Improved Performance</h3>
      <p>Faster startup speed and smoother navigation throughout the app.</p>
      <h3>✓ Bug Fixes</h3>
      <p>Resolved common issues such as crashes, notification delays, and media loading errors.</p>
      <h3>✓ Enhanced Privacy</h3>
      <p>Updated privacy options with better control over online status, read receipts, and chat visibility.</p>
      <h3>✓ Better Android Support</h3>
      <p>Optimized compatibility with newer Android versions for improved stability.</p>
      <h3>✓ UI Improvements</h3>
      <p>Refined interface elements and a cleaner overall user experience.</p>
      <h3>✓ General Optimizations</h3>
      <p>Minor improvements to performance, reliability, and everyday usability.</p>
    </section>

    <section class="section-content">
      <h2>Top Features of GB WhatsApp</h2>
      <p>GB WhatsApp brings more flexibility to your messaging experience with features that go beyond the official WhatsApp app. From advanced privacy controls and personalized themes to smarter messaging tools and enhanced media sharing, it's designed for users who want greater control over how they chat. Explore some of the most popular features below and discover why millions of Android users choose GBWhatsApp.</p>
      <figure class="home-doc-figure home-doc-figure--features">
        <img
          src="@/assets/gb-wave-1.webp"
          alt="GB WhatsApp Privacy features including Ghost Mode and freeze last seen"
          width="1280"
          height="853"
          loading="lazy">
      </figure>
      <div class="top-features-grid">
        <article v-for="f in topFeatures" :key="f.title" class="top-features-grid__item">
          <h3>{{ f.title }}</h3>
          <p>{{ f.body }}</p>
        </article>
      </div>
    </section>

    <section class="section-content">
      <h2>Download Information</h2>
      <p>Check the latest release details before downloading GB WhatsApp. Below are the key specifications for the current version.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">
Information
</th>
            <th scope="col">
Details
</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in apkInfoRows" :key="row.label">
            <th scope="row">
{{ row.label }}
</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="section-content">
      <h2>How to Download and Install GB WhatsApp</h2>
      <p>
        Installing <router-link to="/">GB WhatsApp</router-link> only takes a few minutes.
        Follow these simple <strong>4 Steps</strong> to download, install, and verify the app on your Android device.
      </p>
      <ol class="install-steps">
        <li v-for="step in installSteps" :key="step.title" class="install-steps__item">
          <span class="install-steps__num" aria-hidden="true">{{ step.num }}</span>
          <h3 class="install-steps__title">{{ step.title }}</h3>
          <p class="install-steps__body" v-html="step.body" />
        </li>
      </ol>
      <h3>Before You Install</h3>
      <figure class="home-doc-figure home-doc-figure--install">
        <img
          src="@/assets/gb-wave-2.webp"
          alt="Android install prompt asking to install GB WhatsApp APK"
          width="778"
          height="522"
          loading="lazy"
        >
      </figure>
      <p>✔ Back up your chats before updating or switching devices.</p>
      <p>✔ Make sure your Android device runs Android 5.0 or later.</p>
      <p>✔ Download the latest version from <strong>GB Wave</strong> for the best compatibility and performance.</p>
    </section>

    <section class="section-content">
      <h2>Requirements Before Downloading GB WhatsApp</h2>
      <p>Before downloading GB WhatsApp, make sure your Android device meets the basic requirements. Checking your device in advance helps ensure a smooth installation and better performance after setup.</p>
      <h3>Android Version</h3>
      <p>GB WhatsApp supports <strong>Android 5.0 and above</strong>. Using a newer Android version generally provides better compatibility and stability.</p>
      <h3>Available Storage</h3>
      <p>Keep at least <strong>200 MB of free storage</strong> available to install the APK and allow space for future updates, media files, and chat backups.</p>
      <h3>Recommended RAM</h3>
      <p>A device with <strong>2 GB of RAM</strong> is the minimum requirement, while <strong>4 GB or more</strong> is recommended for smoother multitasking and improved performance.</p>
      <h3>Internet Connection</h3>
      <p>A stable Wi-Fi or mobile data connection is required for phone number verification, downloading updates, restoring backups, and syncing media.</p>
      <h3>Compatible Devices</h3>
      <p>GB WhatsApp works on most Android smartphones, including devices from <strong>Samsung, Xiaomi, OPPO, vivo, realme, Motorola, OnePlus, Google Pixel, Huawei,</strong> and other brands running Android 5.0 or later.</p>
      <h3>✅ Before You Install</h3>
      <p>Before starting the installation, make sure <strong>Install Unknown Apps</strong> is enabled in your Android settings, your battery has enough charge, and you've backed up your chats if you're updating from an older version.</p>
    </section>

    <section class="section-content">
      <h2>Advanced Privacy Controls</h2>
      <p>Protect your privacy with settings that give you more control over your messaging activity. GB WhatsApp includes advanced options that let you decide what others can see, helping you chat more comfortably while keeping your personal activity private.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in privacyRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Customize Your Chat Experience</h2>
      <p>Personalize every part of your messaging app with powerful customization tools. Change the appearance, colors, and layout to create a chat experience that matches your own style.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in customizeRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Share Larger Files Without Limits</h2>
      <p>Share your favorite content more easily with enhanced media support. GB WhatsApp allows you to send larger files and maintain better image and video quality during everyday conversations.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in mediaRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="section-content">
      <h2>Auto Reply and Message Scheduler</h2>
      <p>Save time by automating routine conversations. Whether you're busy, traveling, or managing work messages, these built-in tools help you stay responsive without constantly checking your phone.</p>
    </section>
    <section class="section-content">
      <h2>Status Downloader and Media Tools</h2>
      <p>Manage status updates and media files without relying on additional apps. Built-in tools make it easy to save, organize, and access the content you want to keep.</p>
      <table class="data-table data-table--slim">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in statusToolRows" :key="row.label">
            <th scope="row">{{ row.label }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="section-content">
      <h2>How to Update GB WhatsApp</h2>
      <p>Keeping GB WhatsApp up to date helps improve compatibility, stability, and access to the latest features. Before installing a new version, it's recommended to back up your chats so you can restore your conversations if needed.</p>
      <ol class="update-steps">
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">1</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Back Up Your Chats</h3>
            <p>Create a local backup of your conversations before updating to avoid losing important messages.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">2</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Download the Latest APK</h3>
            <p>Get the newest GB WhatsApp version from <strong>GB Wave</strong> and save the APK to your device.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">3</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Install Over the Existing Version</h3>
            <p>Open the APK and install it without uninstalling your current GB WhatsApp, unless the update guide specifically requires a clean installation.</p>
          </div>
        </li>
        <li class="update-steps__item">
          <span class="update-steps__num" aria-hidden="true">4</span>
          <div class="update-steps__body">
            <h3 class="update-steps__title">Restore Your Chats</h3>
            <p>Open the app, verify your phone number, and restore your local backup if you're prompted during setup.</p>
          </div>
        </li>
      </ol>
      <h3>Update Tips</h3>
      <p>✔ <strong>Back up your chats</strong> before every update.</p>
      <p>✔ <strong>Install over the existing version</strong> whenever possible to help keep your data.</p>
      <p>✔ <strong>Use the latest stable release</strong> for better performance and compatibility.</p>
    </section>

    <section class="section-content">
      <h2>Backup and Restore Your Chats</h2>
      <p>Protect your conversations before updating, reinstalling, or switching to a new device. Creating a backup only takes a few minutes and makes it much easier to restore your chats if something goes wrong during installation or an update.</p>
      <h3>💾 Create a Local Backup</h3>
      <p>Save your chats and media to your device before updating GB WhatsApp.</p>
      <h3>📂 Restore Your Conversations</h3>
      <p>Restore your backup after verifying your phone number during setup.</p>
      <h3>📱 Switch to a New Phone</h3>
      <p>Transfer your local backup to another Android device and continue your chats.</p>
      <h3>🔄 Prevent Data Loss</h3>
      <p>Backing up regularly helps protect important messages, photos, videos, and documents.</p>
      <h3>When Should You Back Up?</h3>
      <p>✔ Before updating to a newer version</p>
      <p>✔ Before reinstalling the app</p>
      <p>✔ Before changing to a new Android phone</p>
      <p>✔ Before clearing app data or resetting your device</p>
    </section>

    <section class="section-content">
      <h2>GB WhatsApp Old Versions</h2>
      <p>While the latest version is recommended for most users, older releases may be helpful if you're using an older Android device, prefer a familiar interface, or encounter compatibility issues after updating. GB Wave also provides archived versions, making it easy to download the release that best fits your device.</p>
      <h3>When Should You Use an Older Version?</h3>
      <p>✔ Your device isn't compatible with the latest release.</p>
      <p>✔ You prefer features or the interface from a previous version.</p>
      <p>✔ You're experiencing issues after updating.</p>
      <p>✔ You need a specific version for testing or compatibility.</p>
      <h3>Popular Old Versions</h3>
      <table class="data-table old-version-table">
        <thead>
          <tr>
            <th scope="col">
Version
</th>
            <th scope="col">
Updated
</th>
            <th scope="col">
Android
</th>
            <th scope="col">
Download
</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in oldVersionRows" :key="row.version">
            <th scope="row">
{{ row.version }}
</th>
            <td>{{ row.updated }}</td>
            <td>{{ row.android }}</td>
            <td>
              <router-link to="/old-versions/">
Download
</router-link>
            </td>
          </tr>
          <tr>
            <th colspan="4" scope="row">
              View All Versions
              <router-link to="/old-versions/">
https://gb-wave.com/old-versions/
</router-link>
            </th>
          </tr>
        </tbody>
      </table>
      <p><strong>Recommended:</strong> For better stability, security, and compatibility, we recommend downloading the <strong>latest GB WhatsApp version</strong> whenever your device supports it.</p>
    </section>

    <section class="section-content">
      <h2>GB WhatsApp vs Official WhatsApp</h2>
      <p>Not sure which version is right for you? The official WhatsApp focuses on simplicity and regular updates, while GB WhatsApp offers additional customization, privacy options, and productivity features for users who want more control over their messaging experience.</p>
      <blockquote class="home-note">
        <strong>Note:</strong> GB WhatsApp is a modified version of WhatsApp and is not developed or endorsed by WhatsApp.
      </blockquote>
      <h3>Feature Comparison</h3>
      <table class="data-table data-table--compare">
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">GB WhatsApp</th>
            <th scope="col">Official WhatsApp</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in compareRows" :key="row.feature">
            <th scope="row">{{ row.feature }}</th>
            <td>
              <span v-if="row.gbMark" class="cmp-mark" :class="`cmp-mark--${row.gbMark}`" aria-hidden="true" />
              <span v-if="row.gbText">{{ row.gbText }}</span>
            </td>
            <td>
              <span v-if="row.offMark" class="cmp-mark" :class="`cmp-mark--${row.offMark}`" aria-hidden="true" />
              <span v-if="row.offText">{{ row.offText }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Which One Should You Choose?</h3>
      <p><strong>Choose GB WhatsApp if you...</strong></p>
      <ul>
        <li>Want more privacy controls.</li>
        <li>Like customizing the app's appearance.</li>
        <li>Need Auto Reply or Message Scheduler.</li>
        <li>Frequently share large photos, videos, and documents.</li>
      </ul>
      <p><strong>Choose Official WhatsApp if you...</strong></p>
      <ul>
        <li>Prefer the official app with automatic updates.</li>
        <li>Want support directly from WhatsApp.</li>
        <li>Don't need additional customization features.</li>
        <li>Prefer installing apps through Google Play.</li>
      </ul>
    </section>

    <section class="section-content">
      <h2>Common Issues and Fixes</h2>
      <p>Most installation or update problems can be resolved in just a few minutes. Below are some of the most common issues reported by GB WhatsApp users and the recommended solutions.</p>
      <h3>GB WhatsApp Not Installing</h3>
      <p>If you are unable to install GB WhatsApp, the problem may be caused by Android security settings, unsupported device versions, insufficient storage, or an incomplete APK download.</p>
      <p>To fix <strong>GB WhatsApp installation problems</strong>, make sure Unknown Sources is enabled, check your Android compatibility, and download the APK file again if the package is damaged.</p>
      <p>
For detailed steps, check our guide on <router-link to="/gb-whatsapp-not-installing/">
<strong>GB WhatsApp Not Installing</strong>
</router-link>.
</p>
      <h3>GB WhatsApp Verification Failed</h3>
      <p>Verification errors usually happen because of incorrect phone numbers, unstable internet connections, delayed OTP messages, or temporary verification restrictions.</p>
      <p>To solve <strong>GB WhatsApp verification issues</strong>, confirm your phone number, use a stable network connection, and wait before requesting another verification code.</p>
      <p>
Read the complete guide: <router-link to="/gb-whatsapp-verification-failed/">
<strong>GB WhatsApp Verification Failed</strong>
</router-link>.
</p>
      <h3>GB WhatsApp Update Failed</h3>
      <p>When updating GB WhatsApp, users may see installation errors due to incompatible APK files, storage limitations, or conflicts with the previous version.</p>
      <p>
Before updating, create a backup and install the <router-link to="/">
latest GB WhatsApp APK
</router-link> over the existing app whenever possible. If the problem continues, follow our guide about <router-link to="/gb-whatsapp-update-failed/">
<strong>GB WhatsApp Update Failed</strong>
</router-link>.
</p>
      <h3><strong>Why Does GB WhatsApp Keep Crashing on Android?</strong></h3>
      <p>If GB WhatsApp keeps stopping or crashing unexpectedly, the issue may be caused by an outdated version, corrupted app files, insufficient storage, or conflicts with previous installations.</p>
      <p>To fix <strong>GB WhatsApp crashing problems</strong>, restart your device, update to the latest version, clear the app cache, or reinstall the APK after creating a backup of your chats.</p>
      <p>For more detailed steps, check our guide on <router-link to="/gb-whatsapp-keeps-crashing/">
<strong>Why Does GB WhatsApp Keep Crashing on Android?</strong>
</router-link>.</p>
      <h3>Can't Restore GB WhatsApp Chats</h3>
      <p>If you can't restore your GB WhatsApp chats, the problem may be caused by an incorrect backup folder, an incompatible backup file, or using a different phone number during the restoration process.</p>
      <p>To fix <strong>GB WhatsApp chat restore problems</strong>, make sure your backup file is stored in the correct location, use the same phone number, and confirm that your backup data is not damaged before restoring.</p>
      <h3>Still Need Help?</h3>
      <p>
If your issue isn't listed above, visit our <strong>Help Center</strong> for step-by-step troubleshooting guides, installation tutorials, and answers to common GB WhatsApp questions.
</p>
      <p>
<router-link to="/troubleshooting/">
View All Troubleshooting Guides →
</router-link>
</p>
    </section>

    <section class="section-content">
      <h2>Is GB WhatsApp Safe? Security and Privacy Risks</h2>
      <p>GB WhatsApp is a modified version of WhatsApp created by independent developers rather than the official WhatsApp team. While many users choose it for its additional features and customization options, using a modified app may involve certain risks that you should understand before installing.</p>
      <h3>Things to Consider</h3>
      <p>🛡️ <strong>Download from a Trusted Source</strong><br>Always download the latest APK from a reliable website to reduce the risk of modified or incomplete files.</p>
      <p>🔄 <strong>Keep the App Updated</strong><br>Installing the latest version helps improve compatibility, fix known issues, and provide a more stable experience.</p>
      <p>💾 <strong>Back Up Your Chats</strong><br>Create a local backup before updating or reinstalling so you can restore your conversations if needed.</p>
      <p>⚠️ <strong>Understand the Risks</strong><br>Because GB WhatsApp is not an official WhatsApp product, its availability and compatibility may change over time, and using modified apps may carry a risk of account restrictions.</p>
      <h3>Our Recommendation</h3>
      <p>If you decide to use GB WhatsApp, keep the app updated, back up your data regularly, and download APK files only from trusted sources. Taking these basic precautions can help you avoid many common installation and update issues. Read our full review at <router-link to="/is-gb-whatsapp-safe/">
<strong>Is GB WhatsApp Safe? Security and Privacy Risks</strong>
</router-link>.</p>
    </section>

    <section class="section-content">
      <h2>Frequently Asked Questions</h2>
      <FAQ :faqs="homeFaqs" variant="home" />
    </section>

    <section class="section-content">
      <h2>Latest Guides &amp; Tips</h2>
      <p>Explore our latest guides to learn how to install, update, back up, and get the most out of GB WhatsApp. These tutorials are regularly updated to help both new and existing users.</p>
      <div class="latest-guides">
        <router-link v-for="post in latestGuides" :key="post.path" :to="post.path" class="latest-guides__card">
          <img :src="post.poster" :alt="post.title" class="latest-guides__img">
          <div>
            <h3>{{ post.title }}</h3>
            <p>{{ post.desc }}</p>
            <time>{{ post.date }}</time>
          </div>
        </router-link>
      </div>
    </section>

    <section class="section-content home-cta">
      <h2>Download GB WhatsApp APK</h2>
      <p>Get the latest version with advanced privacy controls, custom themes, Auto Reply, Message Scheduler, HD media sharing, and many more features.</p>
      <button type="button" class="home-cta__btn" @click="triggerDownload">
        <strong class="home-cta__btn-title">⬇ Download APK</strong>
        <span class="home-cta__btn-meta">Free Download • Latest Version • Android 5.0+</span>
      </button>
    </section>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/gb-wave-home.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import HomeHero from '@/components/HomeHero.vue';
import FAQ from '@/components/FAQ.vue';
import apkDownload from '@/mixins/apkDownload';
import { APK_INFO_ROWS } from '@/utlis/siteConfig';
import { homeFaqs } from '@/documents/homeFaq';
import { guidePosts } from '@/documents/guides.js';

export default {
  name: 'Home',
  components: { HeadNav, HomeHero, FAQ },
  mixins: [apkDownload],
  data() {
    return {
      apkInfoRows: APK_INFO_ROWS,
      homeFaqs,
      privacyRows: [
        { label: 'Ghost Mode', value: 'Stay active while hiding your online presence.' },
        { label: 'Hide Online Status', value: 'Browse and reply without appearing online.' },
        { label: 'Freeze Last Seen', value: 'Keep your last seen timestamp unchanged.' },
        { label: 'Hide Blue Ticks', value: 'Read messages without sending read receipts.' },
      ],
      customizeRows: [
        { label: 'Custom Themes', value: 'Choose from hundreds of unique themes.' },
        { label: 'Fonts & Colors', value: 'Change text styles and interface colors.' },
        { label: 'Chat Wallpapers', value: 'Set different backgrounds for your conversations.' },
        { label: 'App Icons', value: 'Replace the default icon with your preferred style.' },
      ],
      mediaRows: [
        { label: 'HD Photos', value: 'Share clearer images with less compression.' },
        { label: 'Large Videos', value: 'Send longer and larger video files.' },
        { label: 'Multiple Images', value: 'Send more photos in a single message.' },
        { label: 'Documents', value: 'Share PDFs, ZIP files, APKs, and other file types.' },
      ],
      oldVersionRows: [
        { version: 'v18.70', updated: 'Oct 2026', android: '5.0+' },
        { version: 'v18.60', updated: 'Apr 2026', android: '5.0+' },
        { version: 'v18.50', updated: 'Feb 2026', android: '5.0+' },
      ],
      compareRows: [
        { feature: 'Advanced Privacy Controls', gbMark: 'yes', offText: 'Basic' },
        { feature: 'Custom Themes', gbMark: 'yes', offMark: 'no' },
        { feature: 'Auto Reply', gbMark: 'yes', offMark: 'no' },
        { feature: 'Message Scheduler', gbMark: 'yes', offMark: 'no' },
        { feature: 'Status Downloader', gbMark: 'yes', offMark: 'no' },
        { feature: 'HD Media Sharing', gbMark: 'yes', offText: 'Limited' },
        { feature: 'Multiple Accounts', gbMark: 'yes', offText: 'Limited*' },
        { feature: 'Automatic Updates', gbMark: 'no', gbText: 'Manual APK', offMark: 'yes', offText: 'Google Play' },
        { feature: 'Official Support', gbMark: 'no', offMark: 'yes' },
      ],
      statusToolRows: [
        { label: 'Status Downloader', value: 'Save photos and videos from Status.' },
        { label: 'Media Manager', value: 'Organize downloaded files more efficiently.' },
        { label: 'Quick Preview', value: 'View media before saving or sharing.' },
        { label: 'Gallery Access', value: 'Find saved content directly in your device gallery.' },
      ],
      topFeatures: [
        { title: 'Ghost Mode', body: 'Stay connected while keeping your activity private. Ghost Mode helps hide your online presence, giving you more control over when others can see you\'re active.' },
        { title: 'Advanced Privacy', body: 'Manage your last seen, blue ticks, typing indicator, recording status, and online visibility with detailed privacy options.' },
        { title: 'Custom Themes', body: 'Change the look of your app with custom themes, fonts, icons, wallpapers, and color styles to create a personalized chat experience.' },
        { title: 'Auto Reply', body: 'Automatically respond to incoming messages when you\'re busy, driving, or unavailable, making communication more convenient.' },
        { title: 'Message Scheduler', body: 'Schedule messages to be sent at a specific date and time, perfect for reminders, greetings, or important conversations.' },
        { title: 'Status Downloader', body: 'Save photos and videos from your contacts\' status updates directly to your device without using extra apps.' },
        { title: 'HD Media Sharing', body: 'Share high-quality photos, longer videos, documents, and larger files with fewer restrictions than the standard app.' },
        { title: 'Dual Accounts', body: 'Use multiple WhatsApp accounts on the same Android device, making it easier to separate work and personal conversations.' },
      ],
      installSteps: [
        {
          num: '1',
          title: 'Download the APK',
          body: 'Tap the <strong>Download APK</strong> button on GB Wave and save the latest version to your Android device.',
        },
        {
          num: '2',
          title: 'Enable Unknown Sources',
          body: 'Go to <strong>Settings &gt; Security &gt; Install Unknown Apps</strong>, then allow your browser or file manager to install APK files.',
        },
        {
          num: '3',
          title: 'Install GB WhatsApp',
          body: 'Open the downloaded APK and follow the on-screen instructions to complete the installation.',
        },
        {
          num: '4',
          title: 'Verify Your Number',
          body: 'Launch GB WhatsApp, enter your phone number, verify it with the SMS code, and restore your chat backup if available.',
        },
      ],
    };
  },
  computed: {
    // 文档：首页 Latest Guides 仅展示 Guides 栏目最新 3 篇
    latestGuides() {
      return guidePosts
        .slice()
        .sort((a, b) => (a.date < b.date ? 1 : -1))
        .slice(0, 3);
    },
  },
};
</script>

<style scoped>
.home.page {
  background:
    radial-gradient(ellipse 90% 40% at 50% -8%, rgba(40, 167, 69, 0.14), transparent 55%),
    linear-gradient(180deg, #f4fbf6 0, #f6fbf8 980px, #ffffff 1380px);
}

.home-longform {
  position: relative;
  margin-top: -18px;
  padding-top: 24px;
}

/* 首屏 Why Choose：与后续白卡统一，略加大内边距 */
.home-longform .section-content:first-child {
  padding: 1.7rem 1.5rem 1.85rem;
  margin-bottom: 1.65rem;
}

.home-longform__h1 {
  margin: 0 0 1rem;
  padding: 0.1rem 0 0.1rem 0.85rem;
  border-left: 3px solid var(--gb-wave-green, #28a745);
  font-size: clamp(1.45rem, 3vw, 1.85rem);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: #0d3d2a;
}

/* FAQ / CTA 等末尾板块：保持卡片但略减压迫感 */
.home-cta.section-content {
  padding-top: 1.85rem;
  padding-bottom: 2rem;
}

.top-features-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-top: 1.35rem;
}
.top-features-grid__item {
  background: #fff;
  border: 1px solid #e8ecea;
  border-radius: 14px;
  padding: 1rem;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.top-features-grid__item:hover {
  transform: translateY(-3px);
  border-color: #cfe8d7;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.1);
}
.top-features-grid__item h3 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #141a22;
  font-weight: 800;
}
.top-features-grid__item p {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: #5b6573;
}

@media (max-width: 900px) {
  .top-features-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 520px) {
  .top-features-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
.install-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 1.35rem 0 1.65rem;
  padding: 0;
  list-style: none;
  counter-reset: none;
}

.install-steps__item {
  position: relative;
  margin: 0;
  padding: 1rem 0.9rem 1.05rem;
  list-style: none;
  border: 1px solid #dfece4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(24, 76, 43, 0.05);
  text-align: left;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.install-steps__item:hover {
  transform: translateY(-3px);
  border-color: #b7dbc6;
  box-shadow: 0 14px 28px rgba(24, 76, 43, 0.1);
}

.install-steps__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-bottom: 10px;
  border-radius: 50%;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1;
}

.install-steps__title {
  margin: 0 0 0.45rem;
  font-size: 0.98rem;
  font-weight: 800;
  color: #141a22;
  line-height: 1.25;
}

.install-steps__body {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.45;
  color: #5b6573;
}

/* How to Update：竖向时间线，区别于安装区横向卡片 */
.update-steps {
  list-style: none;
  margin: 1.35rem 0 1.5rem;
  padding: 0 0 0 2px;
  position: relative;
}

.update-steps::before {
  content: '';
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 17px;
  width: 2px;
  border-radius: 999px;
  background: linear-gradient(180deg, #28a745 0%, #a8e6c1 100%);
}

.update-steps__item {
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  gap: 14px;
  align-items: flex-start;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

.home-longform .update-steps li + li {
  margin-top: 0;
}

.update-steps__item:last-child {
  margin-bottom: 0;
}

.update-steps__num {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 6px 14px rgba(10, 156, 54, 0.28);
}

.update-steps__body {
  margin: 0;
  padding: 12px 14px;
  border: 1px solid rgba(40, 167, 69, 0.16);
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fcf9 100%);
  box-shadow: 0 6px 16px rgba(18, 76, 43, 0.05);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.update-steps__item:hover .update-steps__body {
  border-color: #b7dbc6;
  box-shadow: 0 10px 22px rgba(18, 76, 43, 0.09);
  transform: translateX(2px);
}

.update-steps__title {
  margin: 0 0 0.35rem !important;
  padding: 0 !important;
  border: 0 !important;
  background: none !important;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.3;
  color: #141a22;
}

.update-steps__body p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #5b6573;
}

@media (prefers-reduced-motion: reduce) {
  .update-steps__item:hover .update-steps__body {
    transform: none;
  }
}

.home-longform .old-version-table {
  width: min(100%, 680px);
  margin: 0.85rem 0 1.45rem;
}

.home-longform .old-version-table th,
.home-longform .old-version-table td {
  padding: 7px 10px;
  font-size: 0.9rem;
}

.home-longform .old-version-table thead th {
  text-align: center;
}

.home-longform .old-version-table tbody th {
  width: auto;
}

@media (max-width: 900px) {
  .install-steps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .install-steps {
    grid-template-columns: minmax(0, 1fr);
  }
}
.home-note {
  background: #f0f7f4;
  border-left: 4px solid var(--gb-wave-green);
  margin: 1.15rem 0 1.35rem;
  padding: 14px 16px;
  border-radius: 0 10px 10px 0;
  line-height: 1.7;
}
.latest-guides {
  display: grid;
  gap: 16px;
  margin-top: 1.15rem;
}
.latest-guides__card {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 14px;
  padding: 14px;
  border: 1px solid #e8ecea;
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  background: #fff;
  overflow: hidden;
  transition:
    transform 0.25s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.25s ease,
    border-color 0.25s ease,
    background 0.2s ease;
}
.latest-guides__card:hover {
  background: #f8faf9;
  transform: translateY(-2px);
  border-color: #cfe8d7;
  box-shadow: 0 14px 30px rgba(18, 76, 43, 0.1);
}
.latest-guides__img {
  width: 100%;
  height: 102px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}
.latest-guides__card:hover .latest-guides__img {
  transform: scale(1.03);
}
.latest-guides__card p {
  margin: 0 0 8px;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
}
.latest-guides__card h3 {
  margin: 0 0 6px;
  font-size: 1.05rem;
  color: #0d3d2a;
}
.latest-guides__card time {
  font-size: 0.85rem;
  color: #888;
}
@media (max-width: 640px) {
  .latest-guides__card {
    grid-template-columns: 1fr;
  }

  .latest-guides__img {
    height: 140px;
  }
}

.home-cta {
  text-align: center;
  padding-bottom: 3rem;
}

/* CTA 居中标题：去掉全局 h2 左边竖杠 */
.home-cta > h2 {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  border-left: 0;
}

.home-cta__btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: min(100%, 320px);
  padding: 14px 28px 12px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #1fd058 0%, #0a9c36 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(9, 157, 53, 0.26);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.home-cta__btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(9, 157, 53, 0.32);
}

.home-cta__btn-title {
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.2;
  color: #fff !important;
}

.home-cta__btn-meta {
  font-size: 0.78rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.3;
  color: #fff;
  opacity: 0.92;
}

@media (max-width: 768px) {
  .home-longform {
    margin-top: -12px;
    padding-top: 16px;
  }

  .home-longform .section-content:first-child {
    padding: 1.25rem 1.05rem 1.4rem;
  }

  .home-longform__h1 {
    font-size: 1.4rem;
  }
}
</style>
